import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isArray, isString } from "../../Utils/Utils";
import { HslAnimation } from "./HslAnimation";
import { OptionsColor } from "./OptionsColor";
export var AnimatableColor = /*#__PURE__*/function (_OptionsColor) {
  _inherits(AnimatableColor, _OptionsColor);

  var _super = _createSuper(AnimatableColor);

  function AnimatableColor() {
    var _this;

    _classCallCheck(this, AnimatableColor);

    _this = _super.call(this);
    _this.animation = new HslAnimation();
    return _this;
  }

  _createClass(AnimatableColor, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(AnimatableColor.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      var colorAnimation = data.animation;

      if (colorAnimation !== undefined) {
        if (colorAnimation.enable !== undefined) {
          this.animation.h.load(colorAnimation);
        } else {
          this.animation.load(data.animation);
        }
      }
    }
  }], [{
    key: "create",
    value: function create(source, data) {
      var color = new AnimatableColor();
      color.load(source);

      if (data !== undefined) {
        if (isString(data) || isArray(data)) {
          color.load({
            value: data
          });
        } else {
          color.load(data);
        }
      }

      return color;
    }
  }]);

  return AnimatableColor;
}(OptionsColor);